import { observable, action, computed } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { getCurrentApp } from "app/api/localTools"
import List from "app/stores/list"

export default class Store {
  @observable keywords = ""
  @observable selectedData = []
  @observable selectedRowKeys = []
  @observable downloadInfo = {}
  @observable list

  @action addSelectedData = data => this.selectedData.push(data)

  @action clearSelected = () => {
    this.selectedData = []
    this.selectedRowKeys = []
  }

  @action deleteData = (dataId) => {
    return request.delete(`${config.backend}/${getCurrentApp()}/datas/${dataId}`)
    .checkToken()
    .commonDispose()
  }

  @action updateData = (dataId, newData) => {
    return request.put(`${config.backend}/${getCurrentApp()}/datas/${dataId}`)
    .send(newData)
    .checkToken()
    .commonDispose()
  }

  @action getDownloadLinks = (dataIds) => {
    return request.post(`${config.backend}/${getCurrentApp()}/datas/downloads`)
    .send(dataIds)
    .checkToken()
    .commonDispose()
  }

  @action getDownloadUrl = (id) => {
    return new Map(this.downloadInfo).get(id)
  }

  @action getHistory = (dataId) => {
    return request.get(`${config.backend}/${getCurrentApp()}/datas/${dataId}/history`)
    .checkToken()
    .commonDispose()
  }

  @computed get downloadLinks () {
    let temp = []
    for (let key in this.downloadInfo) {
      temp.push(this.downloadInfo[key])
    }
    return temp
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "ecs/datas")
    return store
  }

}


// WEBPACK FOOTER //
// ./src/app/stores/ecs/dataManage.js